import styled from 'styled-components';
import {styledByDevice} from '../../../../../themes/architecture/styled-by-device';

const DefaultBox = styled.div`
    text-align: center;
    opacity: 1;
    color: ${props => props.theme.colors.brandSecondary};
`;

export const PcBox = styled(DefaultBox)`
    font-size: 1.4rem;
    font-weight: 600;
`;

export const MobileBox = styled(DefaultBox)`
    font-size: 1.3rem;
    font-weight: 400;
    
    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        font-size: 0.9rem;
    }
`;

export const MinMaxBetAmountDefaultBox = styledByDevice(PcBox, MobileBox);
